import React from 'react';
import SupportContainer from './SupportContainer';

const Support = () => {
  return (
    <>
      <h5 className="mb-5">Support</h5>
      <SupportContainer />
    </>
  )
}

export default Support;